export default "__VITE_ASSET__CuhQHKWN__"